import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './HelpTile.module.css';
import { prependZeroToSingleDigitNumber } from 'shared/utility';

const HelpTile = (props) => {
  let videoFooter = null;
  const tileContainerClasses = [classes.TileContainer];
  if (props.type) tileContainerClasses.push(classes[props.type]);
  const videoDuration = props.videoLengthInSeconds
    ? props.videoLengthInSeconds > 60
      ? `${Math.floor(props.videoLengthInSeconds / 60)}:${prependZeroToSingleDigitNumber(
          Math.floor(props.videoLengthInSeconds - Math.floor(props.videoLengthInSeconds / 60) * 60),
        )}`
      : `0: ${prependZeroToSingleDigitNumber(Math.floor(props.videoLengthInSeconds))}`
    : null;
  if (props.videoUrl) {
    videoFooter = (
      <div className={classes.VideoDetails}>
        <span className={classes.Name}>{props.videoHostName}</span>
        <div className={classes.LengthPlay}>
          <FontAwesomeIcon icon="play-circle" className={classes.PlayIcon} />
          <span>{videoDuration}</span>
        </div>
      </div>
    );
  }
  return (
    <div className={tileContainerClasses.join(' ')} onClick={props.videoUrl ? props.toggle : null}>
      <img src={props.imageUrl} alt={props.key} className={classes.RizaTipImage} />
      {videoFooter}
    </div>
  );
};

export default HelpTile;
